import BpkCard from '@skyscanner-internal/backpack-web/bpk-component-card';
import BpkCloseButton from '@skyscanner-internal/backpack-web/bpk-component-close-button';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import LongArrowRightIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useMBDContext } from '../../common/MBD/useMBDContext';

import type {
  DynamicMapStrings,
  Logo,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/DynamicMapProps';

import STYLES from './PriceMarkerPopup.module.scss';

const AlignedRightArrow = withRtlSupport(LongArrowRightIcon);

export type PriceMarkerPopupProps = {
  index: number;
  address: string;
  logos: Logo[];
  redirectUrl: string;
  popupLinkStr?: string;
  strings: DynamicMapStrings;
  onClose?: () => void;
};

const PriceMarkerPopup = ({
  address,
  index,
  logos,
  onClose = undefined,
  popupLinkStr = undefined,
  redirectUrl,
  strings,
}: PriceMarkerPopupProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  return (
    <BpkCard
      padded={false}
      atomic={false}
      className={STYLES.PriceMarkerPopup__container}
    >
      <div className={STYLES.PriceMarkerPopup__header}>
        {onClose && (
          <BpkCloseButton
            className={STYLES.PriceMarkerPopup__closeButton}
            label="Close"
            onClick={onClose}
            data-tracking-element-id={`${rawComponentName}_popup_close_${index}`}
            data-tracking-common-params={buildMBDParam(
              `${rawComponentName}_popup_close`,
            )}
          />
        )}
        <div className={STYLES.PriceMarkerPopup__providerLogoContainer}>
          {logos.map((logo) => (
            <img key={logo.logoName} src={logo.logoUrl} alt={logo.logoName} />
          ))}
        </div>
      </div>
      {address && (
        <BpkText
          className={STYLES.PriceMarkerPopup__addressInfo}
          tagName="p"
          textStyle={TEXT_STYLES.footnote}
        >
          {address}
        </BpkText>
      )}
      <div className={STYLES.PriceMarkerPopup__redirectLink}>
        <BpkLink
          href={redirectUrl}
          rel="nofollow"
          data-tracking-element-id={`${rawComponentName}_popup_link_${index}`}
          data-tracking-common-params={buildMBDParam(
            `${rawComponentName}_popup_link`,
          )}
        >
          <BpkText textStyle={TEXT_STYLES.body}>
            {strings.markerLink || popupLinkStr}
            {strings.markerLink && strings.markerLink.length > 0 && (
              <span
                className={STYLES.PriceMarkerPopup__redirectLink__arrowRight}
              >
                <AlignedRightArrow />
              </span>
            )}
          </BpkText>
        </BpkLink>
      </div>
    </BpkCard>
  );
};

export default PriceMarkerPopup;
